export interface PollUntilOptions {
  readonly maxAttempts: number;
  readonly intervalMs: number;
}

/** Polls a live readiness signal with a finite attempt and time budget. */
export async function pollUntil<T>(
  resolve: () => T | null | Promise<T | null>,
  options: PollUntilOptions,
): Promise<T | null> {
  for (let attempt = 0; attempt < options.maxAttempts; attempt += 1) {
    const value = await resolve();
    if (value !== null) return value;
    await new Promise<void>((res) => globalThis.setTimeout(res, options.intervalMs));
  }
  return null;
}
